<style scoped>
.chart-item .text {
  padding: 5px 20px 5px 10px;
  width: 100%;
  border-left: 2px solid transparent;
}
.chart-item .text.active {
  border-left: 2px solid #2196f3;
}

</style>
<template>
  <div class="text-xs-center">

    <v-menu
        v-model="showMenu"
        :position-x="x"
        :position-y="y"
        absolute
        offset-y
      >
        <v-list :dense="true" style="width: 150px"> 
          <v-list-tile
            v-for="(item, index) in menuItems"
            :key="index"
          >
            <v-list-tile-title>{{ item.title }}</v-list-tile-title>
          </v-list-tile>
        </v-list>
      </v-menu>
    <!-- offset-x
      position-x="10" -->
    <v-menu v-model="menu" :close-on-content-click="false" :close-on-click="false" :nudge-width="200">
      <template v-slot:activator="{ on }">
        <v-btn
          fab
          dark
          small
          color="indigo"
          v-on="on"
          style="margin-right: 10px"
        >
          <v-icon dark>dashboard</v-icon>
        </v-btn>
      </template>
 
      <v-card style="min-width: 450px; height: 700px; overflow: none">
        <v-list>
          <v-list-tile avatar>
            <v-list-tile-content>
              <v-list-tile-title>Pages</v-list-tile-title>
            </v-list-tile-content>

            <v-list-tile-action>
              <v-btn icon @click="menu = false" >
                <v-icon>close</v-icon>
              </v-btn>
              <!-- <v-btn fab dark small color="primary">
                <v-icon dark>add</v-icon>
              </v-btn> -->
            </v-list-tile-action>
          </v-list-tile>
        </v-list>
        <v-divider></v-divider>
        <div style="height: 600px; overflow-y: auto">
        <v-list :expand="false" :dense="true"> 
          <v-subheader>
             <v-spacer></v-spacer><v-btn icon small v-on:click="aAdd()">
                <v-icon color="primary">create_new_folder</v-icon>
              </v-btn>
          </v-subheader>
          <v-divider></v-divider>
            <v-list-tile 
              v-for="item in charts"
              :key="item.id"
              @contextmenu="show($event)"
            >
              <v-list-tile-content>
                <v-list-tile-title class="chart-item">
                  <input v-model="item.name" class="text" v-on:click="savePrompt(item)" 
        v-bind:class="{ active: item.id === chart.id }" /></v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
        </v-list>
        </div>

      </v-card>
    </v-menu>
  </div>
</template>
<script>
// import charts from "@/store/modules/charts";
import { createNamespacedHelpers } from "vuex";
const chartNamespace = createNamespacedHelpers("charts");
// https://codepen.io/tony-thomas-codepen/pen/bxPJvM
export default {
  // props: ["chart"],
  data: function () {
    return {
      // dialog: false,
      showMenu: false,
      x: 0,
      y: 0,
      menuItems: [
        { title: 'Click Me' },
        { title: 'Click Me' },
        { title: 'Click Me' },
        { title: 'Click Me 2' }
      ],
      items: [
        {
          action: "local_activity",
          title: "Attractions",
          items: [{ title: "List Item" }],
        },
        {
          action: "restaurant",
          title: "Dining",
          active: true,
          items: [
            { title: "Breakfast & brunch" },
            { title: "New American" },
            { title: "Sushi" },
          ],
        },
        {
          action: "school",
          title: "Education",
          items: [{ title: "List Item" }],
        },
        {
          action: "directions_run",
          title: "Family",
          items: [{ title: "List Item" }],
        },
        {
          action: "healing",
          title: "Health",
          items: [{ title: "List Item" }],
        },
        {
          action: "content_cut",
          title: "Office",
          items: [{ title: "List Item" }],
        },
        {
          action: "local_offer",
          title: "Promotions",
          items: [{ title: "List Item" }],
        },
      ],
      fav: true,
      menu: false,
      message: false,
      hints: true,
    };
  },
  components: {},
  methods: {
    show (e) {
      e.preventDefault()
      this.showMenu = false
      this.x = e.clientX
      this.y = e.clientY
      this.$nextTick(() => {
        this.showMenu = true
      })
    },
     ...chartNamespace.mapActions([
      "aCreateRandomDashboard",
      "aAdd",
      "aInit",
      "aUpdate",
      "aSet",
      "aCleanSet",
      "aDelete",
      "aResized",
      "aAddGrid",
      "aActivateGrid",
      "aDownload",
      "aImport"
    ]),
    savePrompt(item) {

      this.aUpdate(this.chart);
      this.aCleanSet(item);
      
      // if(this.chart && item.id === this.chart.id ) {
      //   return;
      // }
      // // if(!this.chart.hasChanged()) {
      // //   this.aCleanSet(item);
      // //   return;
      // // }
      // var r = confirm("Reminder : have you saved your changes ? Click ok to proceed.");
      // // this.aUpdate(chart); 
      // if (r == true) {
      //   this.aCleanSet(item);
      // } else {
      //   // txt = "You pressed Cancel!";
      // }
    }, 
  },
  computed: {
    ...chartNamespace.mapState({
      charts: (state) => state.charts,
      dialogFullscreen: (state) => state.fullscreen,
      dialogTitle: (state) => state.dialogTitle,
      display: (state) => state.display,
      dialog: (state) => state.dialog,
      subChartDialog: (state) => state.subChartDialog,
      showGridMenu: (state) => state.showGridMenu,
      chart: (state) => state.chart,
      subChart: (state) => state.subChart,
      activeGrid: (state) => state.activeGrid,
      activeLayer: (state) => state.activeLayer,
      editable: (state) => state.editable,
      loading: (state) => state.loading,
      progressValue: (state) => state.progressValue,
    }),
  },
  mounted: function () {
    // console.log("chart.list", thchart.list);
  },
  beforeDestroy() {},
};
</script>
